import React, { useState } from "react";
import OverlayBottomRecord from "../_components/OverlayBottomRecord";
import OverlayBottomPlayback from "../_components/OverlayBottomPlayback";
import OverlayBottomThumbnail from "../_components/OverlayBottomThumbnail";

export default function OverlayBottom({
  overlayState,
  handleRecordingComplete,
  setOverlayState,
  isRecording,
  isCameraStreaming,
  timeRemaining,
  startRecord,
  stopRecord,
  playRecording,
  pauseRecording,
  closeModal,
  updateFormField,
  formData,
  hasThumbnail,
  recordedUrl
}) {
  const overlayBottomMarkup = ( overlayState === "ready" || overlayState === "recording" ) ?
    <OverlayBottomRecord
      isRecording={isRecording}
      stopRecord={stopRecord}
      startRecord={startRecord}
      timeRemaining={timeRemaining}
      cameraReady={isCameraStreaming}
    /> :
  ( overlayState === "playback-inProgress" || overlayState === "playback-complete" ) ?
    <OverlayBottomPlayback
      playRecording={playRecording}
      pauseRecording={pauseRecording}
      overlayState={overlayState}
      setOverlayState={setOverlayState}
    /> :
  ( overlayState === "thumbnail" ) ?
    <OverlayBottomThumbnail
      handleRecordingComplete={handleRecordingComplete}
      setOverlayState={setOverlayState}
      formData={formData}
      hasThumbnail={hasThumbnail}
      recordedUrl={recordedUrl}
    />
    : <></>

  return (
    <div className={"gc__overlay_bottom_container"}>
      {overlayBottomMarkup}
    </div>
  );
}
